import { Component, effect, ElementRef, EventEmitter, input, model, Output, signal, viewChild } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-toggle-label-switch',
  imports: [NgClass],
  template: `
    <div
      class="form-check form-switch form-switch-inside-label"
      [ngClass]="{ 'true': currentValue() }">
      <label
        class="form-check-label"
        [ngClass]="{ 'disabled': disabled() }"
        [for]="id()">
        <input
          class="form-check-input"
          (change)="onToggleSwitch()"
          [checked]="currentValue()"
          [disabled]="disabled()"
          type="checkbox"
          [attr.aria-label]="id()"
          #toggleSwitch
          [id]="id()" />
        {{ label() }}
      </label>
    </div>
  `,
  styleUrl: '../../../../../static/styles/components/toggle-label-switch.scss',
})
export class ToggleLabelSwitchComponent {
  initialValue = input<boolean | null>();
  updateValue = model<boolean | null>(null);
  showTooltip = input<boolean>(false);
  tooltipText = input<string>('');
  label = input.required<string>();
  id = input.required<string>();
  iconClass = input<string>('pays-svg-icon ic-card-plus');
  disabled = input<boolean>(false);
  @Output() switchChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  protected currentValue = signal<boolean>(false);

  // Get reference to the checkbox element
  private readonly toggleSwitch = viewChild<ElementRef<HTMLInputElement>>('toggleSwitch');

  constructor() {
    // Reactively update the currentValue when the initialValue changes
    effect(() => {
      const newValue = this.initialValue() ?? false;
      this.currentValue.set(newValue);

      // Manually sync the DOM element's checked state
      const checkbox = this.toggleSwitch()?.nativeElement;
      if (checkbox) {
        checkbox.checked = newValue;
      }
    });

    // Watch for external updates via updateValue model (only when explicitly set)
    effect(() => {
      const updateVal = this.updateValue();

      // Only react if updateValue is explicitly set (not null)
      if (updateVal !== null) {
        this.currentValue.set(updateVal);

        // Manually sync the DOM element's checked state
        const checkbox = this.toggleSwitch()?.nativeElement;
        if (checkbox) {
          checkbox.checked = updateVal;
        }
      }
    });
  }

  onToggleSwitch() {
    const newValue = !this.currentValue();

    // Reset updateValue to null when user interacts
    // This clears any previous programmatic updates
    this.updateValue.set(null);

    this.currentValue.set(newValue);
    this.switchChange.emit(newValue);
  }
}
